import { queryOptions } from "@tanstack/react-query";
import { get2 } from "../axios";

export const getMenuStatusQueryOptions = (branch: number) =>
  queryOptions({
    queryKey: ["menus-statuses", branch],
    queryFn: () => get2(`internal/secure/pos/v1/menus/statusses/${branch}`),
  });

export const getTimeSlotsQueryOptions = (
  branch: number,
  deliveryMethod: number
) =>
  queryOptions({
    queryKey: ["time-slots", branch, deliveryMethod],
    queryFn: () =>
      get2(
        `internal/anonymous/websites/v3/openingTimes/getTimeSlots/temp/${branch}?deliveryMethod=${deliveryMethod}`
      ),
  });

export const getRestaurantMapsQueryOptions = (branchId: number) =>
  queryOptions({
    queryKey: ["restaurantMaps", branchId],
    queryFn: () => get2(`/internal/secure/pos/v1/restaurant/map/${branchId}`),
  });
